
// 初始化默认时间
const defaultDate = function (date_time) {
  var date = date_time
  var year = date.getFullYear().toString()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
  var da = new Date(date.getFullYear(), month, 0).getDate()
  da < 10 ? '0' + da.toString() : da.toString()
  var beg = year + '-' + month + '-01'
  var end = year + '-' + month + '-' + da
  return [beg, end] //将值设置给插件绑定的数据
}

export const rfcToTime = (time) => {
  var date = new Date(time).toJSON();
  var newDate = new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
  return newDate
}

export default defaultDate;